<template>
  <div class="container" @click="onClick">
    <div class="icon"></div>
    <div class="text" v-html="displayText"></div>
  </div>
</template>

<script>
export default {
  computed: {
    displayText() {
      return this.$t('obs.studio.stream.widgets');
    },
  },
  methods: {
    onClick() {
      this.$router.push({ name: 'streamer.widgets' });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import './information-panel'

  .container
    &:hover
      border-color: #9B51E0

  .icon
    background:
      color: #9B51E0
      image: url('~@/assets/svg/obsidian/obs.svg')
</style>
